import Cookies from "js-cookie";

export const compare = {
  el: null,

  init() {
    this.load();
    this.events();
  },

  load() {
    this.el = jQuery(".compare-bar");

    let compareItems = Cookies.get("compare");
    compareItems = compareItems ? JSON.parse(compareItems) : [];

    this.handleVisibility(compareItems);

    if (compareItems.length) {
      this.updateCompareBar(compareItems);
    }

    jQuery(".prod-compare").each((index, element) => {
      if (
        compareItems.find(
          (item) => parseInt(item.id) === parseInt(element.dataset.id)
        )
      ) {
        element.dataset.checked = "true";
      }
    });
  },

  events() {
    // Compare page remove button
    jQuery(".compare-prod__remove").on("click", (e) => {
      let compareItems = Cookies.get("compare");
      compareItems = compareItems ? JSON.parse(compareItems) : [];

      compareItems = compareItems.filter(
        (item) => parseInt(item.id) !== parseInt(e.currentTarget.dataset.id)
      );

      Cookies.set("compare", JSON.stringify(compareItems), { expires: 7 });

      setTimeout(() => {
        window.location.reload();
      }, 150);
    });

    // Handle compare button on product listing
    jQuery(".prod-compare").on("click", (e) => {
      let compareItems = Cookies.get("compare");
      compareItems = compareItems ? JSON.parse(compareItems) : [];

      // Add or remove, data-checked
      if (e.currentTarget.dataset.checked === "true") {
        e.currentTarget.dataset.checked = "false";
        compareItems = compareItems.filter(
          (item) => parseInt(item.id) !== parseInt(e.currentTarget.dataset.id)
        );
      } else if (compareItems.length < 2) {
        e.currentTarget.dataset.checked = "true";
        compareItems.push({
          id: parseInt(e.currentTarget.dataset.id),
          title: e.currentTarget.dataset.title,
          image: e.currentTarget.dataset.image,
          link: e.currentTarget.dataset.link,
        });
      }

      this.handleVisibility(compareItems);

      // Save to session storage
      Cookies.set("compare", JSON.stringify(compareItems), { expires: 7 });

      // Update compare bar
      this.updateCompareBar(compareItems);
    });

    // Compare bar remove all button
    jQuery(".compare-bar__remove").on("click", (e) => {
      Cookies.remove("compare");
      this.updateCompareBar([]);
      this.handleVisibility([]);
      jQuery(".prod-compare").each((index, element) => {
        element.dataset.checked = "false";
      });
    });

    // Compare bar remove button
    this.el.on("click", ".compare-bar-item__remove", (e) => {
      let compareItems = Cookies.get("compare");
      compareItems = compareItems ? JSON.parse(compareItems) : [];

      compareItems = compareItems.filter(
        (item) => parseInt(item.id) !== parseInt(e.currentTarget.dataset.id)
      );

      Cookies.set("compare", JSON.stringify(compareItems), { expires: 7 });

      this.updateCompareBar(compareItems);

      jQuery(`.prod-compare[data-id="${e.currentTarget.dataset.id}"]`).each(
        (index, element) => {
          element.dataset.checked = "false";
        }
      );
    });
  },

  handleVisibility(compareItems) {
    if (compareItems.length < 1) {
      this.el.addClass("compare-bar--hidden");
    } else {
      this.el.removeClass("compare-bar--hidden");
    }
  },

  updateCompareBar(compareItems) {
    const compareBar = jQuery(".compare-bar__list");
    const compareBarItems = compareItems.map((item) =>
      this.renderListing(item)
    );

    if (compareItems.length < 2) {
      compareBarItems.push(this.message());
      jQuery(".compare-bar .btn").addClass("disabled");
    } else {
      jQuery(".compare-bar .btn").removeClass("disabled");
    }

    compareBar.html(compareBarItems.join(""));
    compareBar.toggleClass("compare-bar--hidden", !compareItems.length);
  },

  message() {
    return `<div class="compare-bar-item compare-bar-item--notice">${my_ajax_object.select_1_more_product}</div>`;
  },

  renderListing(data) {
    return `<article class="compare-bar-item">
      <div class="compare-bar-item__image">
        <img src="${data.image}" alt="${data.title}">
      </div>
      <h3 class="compare-bar-item__title"><a href="${data.link}">${data.title}</a></h3>
      <button class="compare-bar-item__remove" data-id="${data.id}" aria-label="Remove ${data.title} from compare">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
      </button>
    </article>`;
  },
};
